(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('EpmParamsController', EpmParamsController);

    EpmParamsController.$inject = ['EpmParams'];

    function EpmParamsController(EpmParams) {

        var vm = this;

        vm.epmParams = [];

        loadAll();

        function loadAll() {
            EpmParams.query(function(result) {
                vm.epmParams = result;
                vm.searchQuery = null;
            });
        }
    }
})();
